import { AccessRestrictedCard } from '@/components/Cards/AccessRestrictedCard/AccessRestrictedCard';
import { Flex } from '@tremor/react';

const TEXT =
  "You don't have the required permissions to access this page. Please contact your organization administrator for assistance.";

export function MissingPermissions() {
  return (
    <Flex justifyContent="center" alignItems="center" style={{ height: '100%' }}>
      <AccessRestrictedCard message={TEXT} />
    </Flex>
  );
}
